import { FormInput, IFormInputProps } from "./FormInput";

export type { IFormInputProps };
export default FormInput;
